import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          综艺索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          按分类快速定位你想看的综艺类型
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.slice(0, 4).map((item) => (
            <div
              key={item.id}
              className="group p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors duration-200"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 mb-3 group-hover:bg-primary-100 transition-colors duration-200">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                {item.description}
              </p>
              <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                {item.count} 档节目
              </span>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {indexData.slice(4, 7).map((item) => (
            <div
              key={item.id}
              className="group p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors duration-200"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 group-hover:bg-primary-100 transition-colors duration-200">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-0.5">
                    {item.title}
                  </h3>
                  <span className="text-xs text-primary-600 font-medium">
                    {item.count} 档节目
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}